import { Database } from 'lucide-react';

/**
 * O nó "estado da sociedade" e os três feixes que descem para os cartões de
 * documento — a tese do produto desenhada: o documento é PROJEÇÃO, quem
 * manda é o estado.
 *
 * Só desktop (`hidden sm:block` no SVG): numa coluna única o olho já lê
 * "estado em cima, documentos embaixo", e o feixe viraria ruído espremido.
 * `aria-hidden` no desenho inteiro — o texto da seção já diz o que ele
 * mostra. O pulso anima em `.feixe__pulso` (`estilos/motion.css`);
 * `preserveAspectRatio="none"` estica o viewBox na largura da grade, então
 * cada curva termina no CENTRO de uma das três colunas (1/6, 3/6, 5/6).
 */
export function FeixeDocumentos(): JSX.Element {
  const caminhos = [
    'M 300 6 C 300 46, 100 40, 100 84',
    'M 300 6 C 300 40, 300 44, 300 84',
    'M 300 6 C 300 46, 500 40, 500 84',
  ];

  return (
    <div aria-hidden className="mt-10 hidden flex-col items-center sm:flex">
      <p className="border-auth-borda/15 bg-auth-superficie/[0.03] rounded-auth-controle text-auth-texto flex items-center gap-2 border px-3.5 py-2 text-xs font-medium tracking-wide">
        <Database size={14} className="text-auth-marca-hover" aria-hidden />O estado da
        sociedade
      </p>
      <svg
        viewBox="0 0 600 88"
        preserveAspectRatio="none"
        className="h-[88px] w-full"
        fill="none"
      >
        {caminhos.map((d, i) => (
          <g key={d}>
            {/* O trilho, estático — presença discreta mesmo sem o pulso
                (reduced-motion) ou antes de ele chegar. */}
            <path d={d} className="stroke-auth-borda/15" strokeWidth="1" />
            <path
              d={d}
              className="feixe__pulso stroke-auth-marca-hover/80"
              strokeWidth="1.5"
              strokeLinecap="round"
              style={{ ['--atraso-feixe' as string]: `${String(i * 1000)}ms` }}
            />
          </g>
        ))}
      </svg>
    </div>
  );
}
